// Generated by ts-to-zod
import { z } from 'zod';
import { integrationCredentialSecretSchema } from '../models/integrationCredential.schema';

export const testExistingIntegrationCredentialPayloadSchema = z.object({
  secret: integrationCredentialSecretSchema,
});
